import { InstallationMeterRecord, InventoryMetersApiClient } from './api/inventoryMeters';
import { RequestConfig } from './httpClient';

export class InventoryMeterInstaller {
  constructor(private readonly meterApiClient: InventoryMetersApiClient) {}

  async install(
    payload: InstallationMeterRecord,
    { authenticator }: Pick<RequestConfig, 'authenticator'> = {},
  ): Promise<void> {
    await this.meterApiClient.install(payload, { authenticator });
  }
}
